import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import * as Sentry from "@sentry/angular";
Sentry.init({
    dsn: "https://92dd03f6c05672772fab9af25754b0f3@o4508301706854400.ingest.de.sentry.io/4508970831708240",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            mutationBreadcrumbLimit: 750,
            mutationLimit: 10000
        }),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", /^https:\/\/mm.auma.com\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});
platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
